var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('reusable-dialog', {
    model: {
      value: _vm.isVisibleDialog,
      callback: function callback($$v) {
        _vm.isVisibleDialog = $$v;
      },
      expression: "isVisibleDialog"
    }
  }, [_c('h3', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('payment.auto.redirection.alert.title'))
    },
    slot: "title"
  }), _c('div', {
    class: _vm.$style.content
  }, [_c('p', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 20,
      expression: "20"
    }],
    domProps: {
      "textContent": _vm._s(_vm.$t('payment.auto.redirection.alert.message.primary'))
    }
  }), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('payment.auto.redirection.alert.message.secondary'))
    }
  })]), _c('div', {
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('simple-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.isVisibleDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('dialog.button.clear')) + " ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }